import { ReactNode } from "react";

import { AlertIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  HStack,
  Text,
  Box,
  Pressable,
} from "@whoosh/design-system/src/components/primitive";

type SettingsButtonProps = {
  onPress: () => void;
  title: string;
  icon?: ReactNode | null;
  showDivider?: boolean;
  variant?: "primary" | "danger";
  testID?: string;
  accessibilityLabel?: string;
  showAlert?: boolean;
};

export const SettingsButton = ({
  onPress,
  title,
  icon,
  showDivider,
  variant = "primary",
  testID,
  accessibilityLabel,
  showAlert = false,
}: SettingsButtonProps) => {
  return (
    <Pressable
      onPress={onPress}
      width="100%"
      testID={testID}
      accessibilityLabel={accessibilityLabel}
    >
      <HStack gap={4} py={5} alignItems="center">
        <Box
          p={3}
          bg={
            variant === "danger"
              ? "surface-status-error-subtlest"
              : "surface-secondary"
          }
          borderRadius="2"
        >
          {icon}
        </Box>
        <Text flexGrow={1} variant="mainBaseMedium">
          {title}
        </Text>
        {showAlert ? (
          <Box
            backgroundColor="surface-status-error-subtle"
            borderRadius="2"
            height={32}
            width={48}
            alignItems="center"
            justifyContent="center"
          >
            <AlertIcon />
          </Box>
        ) : null}
      </HStack>
      {showDivider ? (
        <Box>
          <Box height={1} backgroundColor="surface-dividers" width="100%" />
        </Box>
      ) : null}
    </Pressable>
  );
};
